










































































































































































































































































































































































































































































































































































































































































































































































































































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { IPolicy, PolicyStatus } from 'admiral-core';
import {
  BoxIcon,
  CheckIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  DollarSignIcon,
  Edit2Icon,
  HashIcon,
  MoreVerticalIcon,
  PieChartIcon,
  PlusIcon,
  TrashIcon,
  TrendingUpIcon,
  UserIcon,
  XIcon,
  FileIcon,
} from 'vue-feather-icons';
import dayjs from 'dayjs';
import 'vue-select/dist/vue-select.css';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import Avatar from '@/components/common/Avatar.vue';
import { Util } from '@/utils/Util';
import Multiselect from 'vue-multiselect';
import { FormatMixin } from '@/mixins/FormatMixin';
import PolicyStatusCheckbox from '@/views/pages/policies/PolicyStatusCheckbox.vue';
import HorizontalPolicyStatusSelect from '@/views/pages/policies/HorizonalPolicyStatusSelect.vue';
import PoliciesColumnSelect from '@/views/pages/policies/PoliciesColumnSelect.vue';
import EditPolicyModal from '@/views/pages/policies/EditPolicyModal.vue';
import { PolicyApi } from '@/services/PolicyApi';
import PolicyProductLink from '@/components/common/PolicyProductLink.vue';
import PolicyTagLink from '@/components/common/PolicyTagLink.vue';
import PolicyUserLink from '@/components/common/PolicyUserLink.vue';
import { PermissionMixin } from '@/mixins/PermissionMixin';
import { PreferencesAction } from '@/store/PreferencesModule';
import _get from 'lodash.get';
import AntragsbuchColumnSelect from '@/views/pages/policies/AntragsbuchColumnSelect.vue';
import { BModal } from 'bootstrap-vue';
export type Order = 'desc' | 'asc';
export type ColumnName = string;
export interface SortValue {
  columnName: ColumnName;
  order: Order;
}

export enum PolicyColumn {
  Date = 'Date',
  Status = 'Status',
  Tasks = 'Tasks',
  Customer = 'Customer',
  Product = 'Product',
  User = 'User',
  Value = 'Value',
  Probability = 'Probability',
}

@Component({
  components: {
    AntragsbuchColumnSelect,
    PolicyUserLink,
    PolicyTagLink,
    PolicyProductLink,
    EditPolicyModal,
    PoliciesColumnSelect,
    PlusIcon,

    HorizontalPolicyStatusSelect,
    PolicyStatusCheckbox,
    TrendingUpIcon,
    UserIcon,
    BoxIcon,
    DollarSignIcon,
    HashIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    PieChartIcon,
    MoreVerticalIcon,
    Edit2Icon,
    TrashIcon,
    Avatar,
    Multiselect,
    CheckIcon,
    XIcon,
    FileIcon,
  },
})
export default class PoliciesOverview extends mixins(BaseMixin, FormatMixin, PermissionMixin) {
  @Prop({ required: true, type: Array })
  policies!: IPolicy[];

  @Prop({ required: true, type: Array })
  columns!: ColumnName[];

  @Prop({ type: Boolean, default: () => true })
  search!: boolean;

  @Prop({ required: false, type: Number })
  policiesPerPage!: number;

  @Prop({ type: Boolean, default: () => false })
  isLoading!: boolean;

  @Prop({ type: Boolean, default: () => false })
  embedded!: boolean;

  @Prop({ type: String, required: false, default: 'policies.all' })
  redirectRoute!: string;

  @Prop({ type: Boolean, default: () => false })
  hasSelectItemColumn!: boolean;

  @Prop({ type: Boolean, default: () => true })
  hasAddPolicyButton!: boolean;

  selectedPolicy?: Partial<IPolicy> = {};

  isContentHovered = false;

  scrolled = false;

  PAGES = 10;

  currentPage = 0;
  pagesExpanded = false;

  searchQuery = '';

  sortValue: SortValue = {
    columnName: 'updatedAt',
    order: 'desc',
  };

  get itemsPerPage() {
    return this.policiesPerPage ?? this.policyFilter?.uiItemsPerPage ?? 10;
  }

  async changeItemsPerPage(value: number) {
    if (this.redirectRoute === 'antragsbuch') {
      await this.$store.dispatch(`PreferencesModule/${PreferencesAction.setAntragsbuchFilter}`, {
        ...this.policyFilter,
        uiItemsPerPage: value,
      });
    } else if (this.redirectRoute === 'policies.all') {
      await this.$store.dispatch(`PreferencesModule/${PreferencesAction.setPolicyFilter}`, {
        ...this.policyFilter,
        uiItemsPerPage: value,
      });
    }
  }

  async mounted() {
    window.addEventListener(
      'scroll',
      (event) => {
        if (window.scrollY > 100) {
          this.scrolled = true;
        } else {
          this.scrolled = false;
        }
      },
      false,
    );

    this.$root.$on('reset-policy-filter', () => {
      this.searchQuery = '';
      this.currentPage = 0;
    });

    this.$root.$on('change-policy-filter', () => {
      this.currentPage = 0;
    });

    // Nur auf Anbahnungs-Routen (/vertraege/:id) – nicht in eingebetteter Kunden-Detailansicht (/kunden/:id).
    if (!this.embedded && this.$route.name === 'policies.edit' && this.$route.params.id) {
      try {
        const response = await PolicyApi.getPolicy(this.$route.params.id);
        this.selectedPolicy = response.data;
        (this.$refs['edit-policy-modal'] as any).$refs['edit-policy'].show();
      } catch (e) {
        console.log(e);
      }
    }

    this.$root.$on('bv::modal::hidden', (bvEvent: any, modalId: string) => {
      if (modalId === 'edit-policy' && this.$route.name === 'policies.edit') {
        this.$router.replace({ name: 'policies.all' });
      }
    });
  }

  get policyFilter() {
    if (this.redirectRoute === 'antragsbuch') {
      return this.$store.getters[`PreferencesModule/getAntragsbuchFilter`];
    }

    return this.$store.getters[`PreferencesModule/getPolicyFilter`];
  }

  pagesCount() {
    return Math.ceil(this.filteredPolicies().length / this.itemsPerPage);
  }
  paginationCount() {
    return Math.ceil(this.filteredPolicies().length / this.itemsPerPage);
  }

  @Watch('searchQuery')
  watchSearchQuery() {
    if (this.searchQuery.length === 0 || this.searchQuery.length === 1) {
      this.currentPage = 0;
    }
  }

  filteredPolicies(): IPolicy[] {
    const result: IPolicy[] = this.policies;

    if (this.searchQuery.length > 2) {
      return result.filter((policy: IPolicy) =>
        JSON.stringify(policy).toLowerCase().includes(this.searchQuery.toLowerCase()),
      );
    }
    return result;
  }

  formatOnlyDate(date: Date) {
    return Util.formatDate2(date);
  }

  formatDate(date: Date) {
    return Util.formatDate(date);
  }

  formatDateFull(date: Date) {
    return dayjs(date).format('DD.MM.YYYY HH:mm');
  }

  progressBarColor(probability: number) {
    if (probability >= 7) {
      return 'progress-bar-success';
    } else if (probability >= 3) {
      return 'progress-bar-secondary';
    } else {
      return 'progress-bar-danger';
    }
  }

  get sortedList() {
    const columnName: keyof IPolicy = this.sortValue.columnName as keyof IPolicy;

    const compare = (a: IPolicy, b: IPolicy) => {
      let aValue =
        typeof _get(a, columnName) === 'object' && _get(a, columnName) !== null
          ? (_get(a, columnName) as { id: string }).id
          : _get(a, columnName) !== null
          ? _get(a, columnName)
          : 0;
      let bValue =
        typeof _get(b, columnName) === 'object' && _get(b, columnName) !== null
          ? (_get(b, columnName) as { id: string }).id
          : _get(b, columnName) !== null
          ? _get(b, columnName)
          : 0;

      if (!isNaN(aValue) && !isNaN(bValue)) {
        aValue = Number(aValue);
        bValue = Number(bValue);
      }

      if (aValue < bValue) {
        return this.sortValue.order === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return this.sortValue.order === 'asc' ? 1 : -1;
      }
      return 0;
    };
    return this.filteredPolicies().sort(compare);
  }

  get totalLeads() {
    return this.filteredPolicies().length;
  }

  get totalLeadsValue() {
    return this.filteredPolicies().reduce((a, b) => {
      return a + b.value;
    }, 0);
  }
  get totalTopLeadsValue() {
    return this.filteredPolicies().reduce((a, b) => {
      return a + (b.probability >= 7 ? b.value : 0);
    }, 0);
  }

  get countLeadsCustomers() {
    const customers: Record<string, string> = {};

    this.filteredPolicies().forEach((lead: IPolicy) => {
      if (lead.customer) {
        customers[lead.customer] = lead.customer;
      }
    });

    return Object.keys(customers).length;
  }

  get avgLeadValue() {
    const value = Math.round(this.totalLeadsValue / this.totalLeads);
    return !Number.isNaN(value) ? value : 0;
  }

  get getPaginatedItems() {
    return this.sortedList.slice(
      this.currentPage * this.itemsPerPage,
      this.currentPage * this.itemsPerPage + this.itemsPerPage,
    );
  }

  relativeValueStr(policy: IPolicy) {
    if (policy.relativeValue < 100) {
      return Math.round(policy.value * (policy.relativeValue / 100)).toLocaleString('de-DE');
    }

    return '-';
  }

  hasSort(columnName: ColumnName, order: Order) {
    return this.sortValue.columnName === columnName && this.sortValue.order === order;
  }

  hasColumn(columnName: ColumnName) {
    return this.selectedColumns.includes(columnName);
  }

  get selectedColumns(): string[] {
    if (this.embedded) {
      return this.columns;
    }
    if (this.redirectRoute === 'policies.all') {
      return this.$store.state.PreferencesModule.policiesColumns;
    } else if (this.redirectRoute === 'antragsbuch') {
      return this.$store.state.PreferencesModule.antragsbuchColumns;
    }

    return this.$store.state.PreferencesModule.policiesColumns;
  }

  setSort(columnName: ColumnName, order: Order) {
    this.sortValue = {
      columnName,
      order,
    };
  }

  isNew(policy: IPolicy) {
    return dayjs(policy.createdAt).isSame(dayjs(), 'date');
  }

  async selectPolicy(policy: IPolicy) {
    if (this.hasSelectItemColumn) {
      this.$emit('select-policy', policy);
    } else {
      await this.openEditModal(policy);
    }
  }

  async openEditModal(policy: IPolicy) {
    this.selectedPolicy = policy;
    // await this.$router.push({ name: 'policy.update', params: { id: policy.id } }).catch((err) => {
    //   //
    // });

    // eslint-disable-next-line
    (this.$refs['edit-policy-modal'] as any).$refs['edit-policy'].show();
  }

  @Watch('selectedPolicy')
  onSelectedPolicyChange() {
    if (this.selectedPolicy && Object.keys(this.selectedPolicy).length > 0) {
      ((this.$refs['edit-policy-modal'] as EditPolicyModal).$refs['edit-policy'] as BModal).show();
    }
  }

  async reload(updatedPolicy?: IPolicy) {
    if (updatedPolicy) {
      this.selectedPolicy = updatedPolicy;
    }
    this.$emit('reload');
  }
  async selectNext() {
    const index = this.sortedList.findIndex(
      (policy: IPolicy) => policy.id === this.selectedPolicy?.id,
    );

    if (index + 1 >= this.sortedList.length) {
      this.selectedPolicy = this.sortedList[0];
    } else {
      this.selectedPolicy = this.sortedList[index + 1];
    }
    // await this.$router
    //   .push({ name: 'policy.update', params: { id: this.selectedPolicy.id! } })
    //   .catch((err) => {
    //     //
    //   });
  }

  async selectPrev() {
    const index = this.sortedList.findIndex(
      (policy: IPolicy) => policy.id === this.selectedPolicy?.id,
    );

    if (index - 1 < 0) {
      this.selectedPolicy = this.sortedList[this.sortedList.length - 1];
    } else {
      this.selectedPolicy = this.sortedList[index - 1];
    }
    // await this.$router
    //   .push({ name: 'policy.update', params: { id: this.selectedPolicy.id! } })
    //   .catch((err) => {
    //     //
    //   });
  }
  taskTitle(quantity: number) {
    return quantity === 1 ? `${quantity} Task` : `${quantity} Tasks`;
  }

  handleFilterCustomer(customerName: string) {
    if (this.embedded) {
      return;
    }
    this.searchQuery = this.searchQuery === customerName ? '' : customerName;
    this.currentPage = 0;
  }
}
